import type { ShowWhen } from '@doneverse/shared'

export interface SchemaField {
  id: string | number
  type?: 'section'
  title?: string
  question?: string
  description?: string
  field_type?: 'short_text' | 'long_text' | 'single_select' | 'multi_select' | 'rank'
  displayAs?: 'checkbox' | 'radio' | 'long_text_xl' | 'image_select' | 'multi_list' | 'searchable_select'
  options?: string[]
  optionImages?: Record<string, string>
  showWhen?: ShowWhen
  required?: boolean
}

/**
 * Returns the effective display type for rendering.
 * Uses displayAs if set, otherwise falls back to field_type.
 */
export function getEffectiveDisplayType(field: SchemaField): string {
  return field.displayAs || field.field_type || 'short_text'
}

export interface BriefSchema {
  id: string
  form_type: 'founder' | 'doer'
  schema: SchemaField[]
}
